export default __webpack_public_path__ + "static/media/Ring of Protection.88739c6e.jpg";